module.exports = __webpack_public_path__ + "media/configurations/X-X-O-7ee1a200.png";